import {
  GetProductInfo,GetMemberDetail,
  postLogin, RestPwd, ForgetMemPwd, Register, RefreshToken, GetMemberInfo, ChangeMemPwd,
  GetHistoryLog, GetOrderLog, GetPurchaseLog,GetCurencyPlan,
  PostClientVip, PostLoverVip, PostRelativewesVip, PostColleagueVip,
  GetAllyearFree, PostAllyearVip, GetPersonalityFree, PostPersonalityVip,
  PostPhoneFree, PostPhoneVip, PostGameblingFree, PostGameblingVip, PostOverallVip,
  PostAnaHistory, PostPrecision,
  GetDailyCard,GetPoint,Ecpay,getProduct,
  MasterTips,GetHomeCard,
  getInvite,delInvitePlanClean,SalesEcpay,SalesSocialPlan,
  SearchClient,InviteClient,SalesPlan,MyInviteClient,SendPlanToClient,ReturnInviter,
  LineAuth,LineLogin,LineRegister,
  EditMemberInfo,
  getSalesPerformance,getSalesOrder,getSalesUpgrade,InviteSocialClient,
  getMySalesTeam,getMyClient,
  getPaymentLog,
  getShareCodeCheck,
  SendVerifCode,
  getCheckInvitecode,getCheckSales,
  DisabledView,PointGift,
  getSalesBank,postSalesBank,postUpload,getTrandno,
  getAppStatus,NBpay,PayCancel,SalesNBpay,PuidDo,savePWD,
  TestDev,ErrSend,ProductNew,MyInviteClientNew,
  ChackOut,PayChackOut

} from '../service/api'

import * as rootypes from './mutations_type'
// import Vue from 'vue';
// import {getStore} from "../config/mUtils";

export default {
  /** product data */
  async actionGetProductInfo ({commit}, data) {
    try {
      let res = await GetProductInfo()
      if (res.result == 1) {
        commit(rootypes.RECODE_PRODUCTDATA, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)

    }
  },

  /** login */
  async actionGetToken ({commit}, data) {
    try {
      let res = await postLogin(data)
      if (res.result == 1) {
        commit(rootypes.RECODE_TOKEN, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** logout */
  actionLogout ({commit}) {
    commit(rootypes.LOGOUT) // success 清空 token
  },
  /** Register */
  async actionRegister ({commit}, data) {
    try {
      let res = await Register(data)
      if (res.result == 1) {
        commit(rootypes.RECODE_TOKEN, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionSendVerifCode ({commit}, data) {
    try {
      let res = await SendVerifCode(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** RefreshToken */
  async actionRefreshToken ({commit}, data) {
    try {
      let res = await RefreshToken()
      if (res.result == 1) {
        commit(rootypes.RECODE_TOKEN, res.data)
      }
      let ress = await GetMemberInfo()
      if (ress.result == 1) {
        commit(rootypes.RECODE_MEMBERINFO, ress.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** RestPwd (check) */
  async actionRestPwd ({commit}, data) {
    try {
      let res = await RestPwd(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** ChangeMemPwd */
  async actionChangeMemPwd ({commit}, data) {
    try {
      let res = await ChangeMemPwd(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** ForgetMemPwd (check) */
  async actionForgetMemPwd ({commit}, data) {
    try {
      let res = await ForgetMemPwd(data)
      if (res.result == 1) {
        commit(rootypes.FORGETPWD, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** GetPoint */
  async actionGetPoint ({commit}, data) {
    try {
      let res = await GetPoint()
      if (res.result == 1) {
        commit(rootypes.RECODE_POINT, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** GetPoint */
  async actionGetCurencyPlan ({commit}, data) {
    try {
      let res = await GetCurencyPlan()
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** GetMemberInfo */
  async actionGetMemberInfo ({commit}, data) {
    try {
      let res = await GetMemberInfo(data)
      if (res.result == 1) {
        commit(rootypes.RECODE_MEMBERINFO, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionGetMemberDetail ({commit}, data) {
    try {
      let res = await GetMemberDetail(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },



  /** Log */
  async actionGetHistoryLog ({commit}, data) {
    try {
      let res = await GetHistoryLog(data)
      if (res.result == 1 && data.offset == 0) {
        commit(rootypes.RECODE_HISTORYLOG, res.data)
      } else {
        commit(rootypes.PUSH_HISTORYLOG, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionGetOrderLog ({commit}, data) {
    try {
      let res = await GetOrderLog(data)
      if (res.result == 1 && data.offset == 0) {
        commit(rootypes.RECODE_USELOG, res.data)
      } else {
        commit(rootypes.PUSH_USELOG, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionGetPurchaseLog ({commit}, data) {
    try {
      let res = await GetPurchaseLog(data)
      if (res.result == 1 && data.offset == 0) {
        commit(rootypes.RECODE_PAYMENTLOG, res.data)
      } else {
        commit(rootypes.PUSH_PAYMENTLOG, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** DailyCard */
  async actionGetDailyCard({commit}, data) {
    try {
      let res = await GetDailyCard(data)
      if (res.result == 1 ) {
        commit(rootypes.RECODE_DAILYDATA, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** Analysis */
  async actionAnaResult ({commit}, data) {
    commit(rootypes.RECODE_ANASUBRESULT, {});
    commit(rootypes.RECODE_ANARESULT, {});

    try {
      let res
      switch (data.producttype) {
        case 'PersonalityFree':
          res = await GetPersonalityFree()
          break
        case 'PersonalityVip':
          res = await PostPersonalityVip()
          break
        case 'AllyearFree':
          res = await GetAllyearFree()
          break
        case 'AllyearVip':
          res = await PostAllyearVip()
          break
        case 'Client':
          res = await PostClientVip(data)
          break
        case 'Colleague':
          res = await PostColleagueVip(data)
          break
        case 'Love':
          res = await PostLoverVip(data)
          break
        case 'Relativewes':
          res = await PostRelativewesVip(data)
          break
        case 'Overall':
          res = await PostOverallVip(data)
          break
        case 'PhoneFree':
          res = await PostPhoneFree(data)
          break
        case 'PhoneResult':
          res = await PostPhoneVip(data)
          break
        case 'MasterFree':
          res = await PostGameblingFree(data)
          break
        case 'MasterResult':
          res = await PostGameblingVip(data)
          break
      }
      if (res.result == 1) {
        if(data.producttype == 'MasterResult' ||
          data.producttype == 'PhoneResult'
        ){
          commit(rootypes.RECODE_ANASUBRESULT, res.data)
        }else{
          commit(rootypes.RECODE_ANARESULT, res.data)
        }

      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionPostAnaHistory ({commit}, data) {
    try {

      let res = await PostAnaHistory(data)
      if (res.result == 1) {
        if(data.type == '3' || data.type == '9'
        ){
          commit(rootypes.RECODE_ANASUBRESULT, res.data)
        }else{
          commit(rootypes.RECODE_ANARESULT, res.data)
        }      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** Ecpay  */
  async actionGetProductWebID({commit}, data) {
    try {
      let res = await getProduct(data)
      commit(rootypes.RECODE_PLAN, res.data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionECpay({commit}, data) {
    try {
      let res = await Ecpay(data)
       // let res = await TestDev()

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** CheckOut NBpay  */
  async actionCheckOut({commit}, data) {
    try {
      let res = await ChackOut(data)
      // let res = await PayChackOut(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionCancelTrandno({commit}, data) {
    try {
      let res = await PayCancel(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },




  async actionShopCart({commit}, data) {
    commit(rootypes.RECODE_SHOPCART, data)
  },
  async actionOrderPurchase({commit}, data) {
    commit(rootypes.RECODE_ORDERPURCHASE, data)
  },
  /** MasterTips  */
  async actionGetMasterTips({commit}, data) {
    try {
      let res = await MasterTips(data)
      commit(rootypes.RECODE_MASTERTIPS, res.data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** Home Card  */
  async actionGetHomeCard({commit}, data) {
    try {
      let res = await GetHomeCard(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** Shop Card  */
  async actionGetInvite({commit}, data) {
    try {
      let res = await getInvite(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionInvitePlanClean({commit}, data) {
    try {
      let res = await delInvitePlanClean(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** Invite fun  */

  async actionSearchClient({commit}, data) {
    try {
      let res = await SearchClient(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionInviteClient({commit}, data) {
    try {
      let res = await InviteClient(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionInviteSocialClient({commit}, data) {
    try {
      let res = await InviteSocialClient(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionPointGift({commit}, data) {
    try {
      let res = await PointGift(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },



  async actionSalesPlan({commit}, data) {
    try {
      let res = await SalesPlan(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionSalesSocialPlan({commit}, data) {
    try {
      let res = await SalesSocialPlan(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionMyInviteClient({commit}, data) {
    try {
      let res = await MyInviteClient(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionMyInviteClientNew({commit}, data) {
    try {
      let res = await MyInviteClientNew(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionSendPlanToClient({commit}, data) {
    try {
      let res = await SendPlanToClient(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionReturnInviter({commit}, data) {
    try {
      let res = await ReturnInviter(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** VIPECpay  */
  async actionSalesECpay({commit}, data) {
    try {
      let res = await SalesEcpay(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionSalesNBpay({commit}, data) {
    try {
      let res = await SalesNBpay(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionPuidDo({commit}, data) {
    try {
      let res = await PuidDo(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },

  /** Trandno  */
  async actionGetTrandno({commit}, data) {
    try {
      let res = await getTrandno(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** LINE  */
  async actionLineAuth({commit}, data) {
    try {
      let res = await LineAuth(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionLineLogin({commit}, data) {
    try {
      let res = await LineLogin(data)
      if (res.result == 1 && res.data.register_status == true) {
        commit(rootypes.RECODE_TOKEN, res.data.token)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionLineRegister({commit}, data) {
    try {
      let res = await LineRegister(data)
      if (res.result == 1 && res.data.register_status == true) {

        commit(rootypes.RECODE_TOKEN, res.data.token)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionEditMemberInfo({commit}, data) {
    try {
      let res = await EditMemberInfo(data)
      if (res.result) {
        commit(rootypes.UPDATA_PROFILE, data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** Sales Performance  */

  async actionGetSalesPerformance({commit}, data) {
    try {
      let res = await getSalesPerformance(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionGetgetSalesOrder({commit}, data) {
    try {
      let res = await getSalesOrder(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** Sales   */

  async actionGetMySalesTeam({commit}, data) {
    try {
      let res = await getMySalesTeam(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionGetMyClient({commit}, data) {
    try {
      let res = await getMyClient(data)
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** oeder history   */
  async actionGetPaymentLog({commit}, data) {
    try {

      let res = await getPaymentLog(data)
      if (res.result == 1 && data.offset == 0) {
        commit(rootypes.RECODE_PAYMENTLOG, res.data)
      } else {
        commit(rootypes.PUSH_PAYMENTLOG, res.data)
      }
      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** share code   */
  async actionGetShareCodeCheck({commit}, data) {
    try {
      let res = await getShareCodeCheck(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** sales share code   */
  async actionGetCheckInvitecode({commit}, data) {
    try {
      let res = await getCheckInvitecode(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionGetCheckSales({commit}, data) {
    try {
      let res = await getCheckSales(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** disable history   */
  async actionDisabledView({commit}, data) {
    try {
      let res = await DisabledView(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  /** sales bank */
  async actionGetSalesBank({commit}, data) {
    try {
      let res = await getSalesBank(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionPostSalesBank({commit}, data) {
    try {
      let res = await postSalesBank(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionPostUpload({commit}, data) {
    try {
      let res = await postUpload(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionGetAppStatus({commit}, data) {
    try {
      let res = await getAppStatus(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionPWD({commit}, data) {
    try {
      let res = await savePWD(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionErrSend({commit}, data) {
    try {
      let res = await ErrSend(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async actionProductNew({commit}, data) {
    try {
      let res = await ProductNew(data)

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e)
    }
  },











}
